export const updates = [
    {
        id: 19,
        date: '2025-10-15',
        note: 'Lots of new pages for emo music website',
    },
    {
        id: 18,
        date: '2025-04-06',
        note: 'Lots of new pages for witch-house music website',
    },
    {
        id: 17,
        date: '2025-03-04',
        note: 'Added poetry page',
    },
    {
        id: 16,
        date: '2025-03-03',
        note: 'Photo and video updates',
    },
    {
        id: 15,
        date: '2024-08-05',
        note: 'New pages for emo music website',
    },
    {
        id: 14,
        date: '2024-07-14',
        note: 'New pages for emo music website',
    },
    {
        id: 13,
        date: '2024-06-25',
        note: 'New pages for witch-house website',
    },
    {
        id: 12,
        date: '2024-04-18',
        note: 'Update photos and video pages',
    },
    {
        id: 11,
        date: '2024-03-28',
        note: 'Finish main witch-house page',
    },
    {
        id: 10,
        date: '2024-03-24',
        note: 'Create movies page',
    },
    {
        id: 9,
        date: '2024-03-23',
        note: 'Create video gallery page',
    }, {
        id: 8,
        date: '2024-03-23',
        note: 'Create bgs, icons page',
    }, {
        id: 7,
        date: '2024-03-21',
        note: 'Create games page',
    }, {
        id: 6,
        date: '2024-03-19',
        note: 'Finished with photo pages',
    }, {
        id: 5,
        date: '2024-01-09',
        note: 'Working on photos pages, add api functionality',
    }, {
        id: 4,
        date: '2023-09-04',
        note: 'End main template of site, add side components and info page',
    }, {
        id: 3,
        date: '2023-08-19',
        note: 'Create united project and start main site',
    }, {
        id: 2,
        date: '2023-08-10',
        note: 'Start working on witch house page',
    }, {
        id: 1,
        date: '2022-08-04',
        note: 'End emo main page and create first band page',
    }, {
        id: 0,
        date: '2022-08-02',
        note: 'Start working on emo page',
    }];